import { render } from "./SessionsPerService.vue?vue&type=template&id=2bded700&ts=true"
import script from "./SessionsPerService.ts?vue&type=script&lang=ts&external"
export * from "./SessionsPerService.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__